import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindListeCreateursContent($id: String!)
{
  creators: queryCornerMarqueContents(top: 100, skip: 0, filter: "data/typeMarque/iv eq 'robes'", search: null, orderby: "data/pageTitle/iv") {
    id
    data {
      brandId {
        iv
      }
      pageTitle {
        iv
      }
      thumbTitle {
        iv
      }
      thumbSubTitle {
        iv
      }
      thumbImage {
        iv {
          url
          fileSize
        }
      }
    }
  }
  content: findListeCreateursContent(id: $id) {
    data {
      brandId{
        iv
      }
      titleBlocTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaStyle {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
        }
      }
      titleBlocTextColor {
        iv
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }
      description {
        iv
      }
      descriptionFontSize {
        iv
      }
      descriptionTextColor {
        iv
      }

      showroom {
        iv{id}
      }
    }
  }
}
`,
]);
